import { useFeatureFlagEnabled } from '@frameio/feature-flags';
import { useGetLabsExperimentEnrollmentsQuery } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '../contexts';

/**
 * Slugs of Labs experiments that feature code gates on. Each value must match
 * the `slug` of a `LabsExperiment` returned by the API.
 */
export type LabsExperimentSlug =
  | 'folder_colors'
  | 'firefly_actions'
  | 'faster_playback';

/**
 * Returns whether a Labs feature should be shown: the account must have the
 * `v4.labs` feature flag enabled AND be enrolled in the given experiment via
 * the Labs settings page.
 */
export function useIsLabsFeatureEnabled(slug: LabsExperimentSlug) {
  const accountId = useActiveAccountId();

  const isLabsEnabled = useFeatureFlagEnabled('v4.labs');

  const { data } = useGetLabsExperimentEnrollmentsQuery({
    variables: { accountId: accountId ?? '' },
    skip: !accountId || !isLabsEnabled,
  });

  const isEnrolled =
    data?.account?.labsExperiments?.nodes.some(
      (experiment) => experiment.slug === slug && experiment.enrolled
    ) ?? false;

  return isLabsEnabled && isEnrolled;
}
